import React from "react";
import Skeleton from "react-loading-skeleton";

export const HybridpageRightLoader = () => {
  return (
    <div className="productsDetail-rht">
      {/* Seller + Title */}
      <div className="product-detail-info">
        <Skeleton width="80%" height={30} />
        <Skeleton width="60%" height={20} />
        <div style={{ display: "flex", gap: "1rem" }}>
          <Skeleton width="30%" height={20} />
          <Skeleton width="30%" height={20} />
        </div>
      </div>

      {/* Price + Options */}
      <div className="product-price-length">
        <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <h2 style={{ margin: 0 }}>$</h2> <Skeleton width="27%" height={50} />
        </span>
        <Skeleton width="30%" height={50} />
      </div>

      {/* Quantity + Buttons */}
      <div className="pro-qty-list">
        <Skeleton width="50%" height={40} />
        <div style={{ display: "flex", gap: "1rem" }}>
          <Skeleton circle width={40} height={40} />
          <Skeleton circle width={40} height={40} />
          <Skeleton circle width={40} height={40} />
        </div>
      </div>
    </div>
  );
};
